import Styled from 'styled-components';
import { CardLabel } from '@amount/frontend-components';

export const CategoryHeader = Styled(CardLabel)`
  margin-top: 1em;
`;
